/**
 * Makes sure an element is defined only once
 * @param {string} tagName
 * @param {any} elementClass
 */
const defineRefiElement = (tagName, elementClass) => {
  if (!customElements.get(tagName)) {
    customElements.define(tagName, elementClass);
  }
};

export { defineRefiElement };
